import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export function ChartLoadingMessage() {
  return (
    <Stack
      sx={{
        borderRadius: 2,
        height: 450,
      }}
      spacing={1}
      alignItems="center"
      justifyContent="center"
      data-role="chart-loading-message"
    >
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        whiteSpace="break-spaces"
      >
        We're cooking rich data for you. Please bear with us.
      </Typography>
      <Box>
        <CircularProgress />
      </Box>
    </Stack>
  );
}
